// extracted by mini-css-extract-plugin
module.exports = {"news":"single-news-module--news--3Wswm","center":"single-news-module--center--rerp9","post":"single-news-module--post--2Q3tZ","download":"single-news-module--download--2XcK3"};